// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"internal-module--pageTitle--2g1R3","mainContent":"internal-module--mainContent--YuRcs","button":"internal-module--button--1WNVP"};